export type RefreshTier = 'A' | 'B' | 'C' | 'D';

export interface TierConfig {
    minMs: number;
    maxMs: number;
    defaultMs: number;
}

export const REFRESH_TIERS: Record<RefreshTier, TierConfig> = {
    A: { minMs: 250, maxMs: 1000, defaultMs: 500 },
    B: { minMs: 2000, maxMs: 5000, defaultMs: 3000 },
    C: { minMs: 10000, maxMs: 30000, defaultMs: 15000 },
    D: { minMs: 60000, maxMs: 900000, defaultMs: 60000 },
};

export interface TimedValue {
    t: number;
    v: number;
}

export interface OHLCTick {
    t: number;
    o: number;
    h: number;
    l: number;
    c: number;
    volume?: number;
}

export interface CandlePoint {
    ts: number;
    open: number;
    high: number;
    low: number;
    close: number;
    volume: number;
}

export interface StaleState {
    stale: boolean;
    ageMs: number;
    thresholdMs: number;
}
